import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/SoftwareCrestest.css";

// Import required asset paths (adjust paths based on your file structure)
import aboutImage from "../../images/soft-right1.png"; // Replace with your desired image path

function SoftwareCrestest({ onComingSoonTrigger }) {
    // Local modal fallback state if a handler isn't passed from parent
    const [localComingSoonModal, setLocalComingSoonModal] = useState(false);

    const handleChallengeClick = () => {
        if (typeof onComingSoonTrigger === 'function') {
            onComingSoonTrigger();
        } else {
            setLocalComingSoonModal(true);
        }
    };

    return (
        <section className="sw-crestest-info-section">
            <div className="container">
                <div className="row align-items-stretch">

                    {/* Left Side Content */}
                    <div className="col-lg-6 d-flex align-items-center">
                        <div className="sw-crestest-left-content">
                            <p className="sw-crestest-small-text">EDTECH SOFTWARE SOLUTIONS</p>

                            <h2 className="sw-crestest-heading">
                                Building Smarter Digital Solutions for Education
                            </h2>

                            {/* The Zigzag Accent */}
                            <div className="sw-crestest-zigzag-border mb-3"></div>

                            <p className="sw-crestest-sub-text">
                                <Link to="/" className="sw-crestest-wiki-link">
                                    Crestest
                                </Link>{" "}
                                develops innovative EdTech software solutions that help schools,
                                institutes, and educational organizations simplify operations,
                                enhance learning, and build connected digital ecosystems.
                            </p>

                            <p className="sw-crestest-sub-text mt-3">
                                From{" "}
                                <Link to="/Associates" className="sw-crestest-wiki-link">
                                    Academic ERP
                                </Link>{" "}
                                and learning management systems to online examination platforms,
                                student portals, assessment tools, and customized educational
                                applications, we create technology around the specific needs of
                                every institution.
                            </p>

                            <p className="sw-crestest-sub-text mt-3">
                                Our{" "}
                                <Link to="/software" className="sw-crestest-wiki-link">
                                    Custom EdTech Software Solutions
                                </Link>{" "}
                                combine modern technology, intuitive design, automation, and
                                scalable architecture to support institutions in their digital
                                transformation journey.
                            </p>

                            <Link to="/software" className="btn sw-crestest-btn mt-3">
                                EXPLORE SOLUTIONS
                            </Link>
                        </div>
                    </div>

                    {/* Right Side Image (Full Width & Height of Grid Box) */}
                    <div className="col-lg-6 px-4">
                        <div className="sw-crestest-right-img-wrap">
                            <img
                                src={aboutImage}
                                alt="About Us"
                                className="sw-crestest-full-image"
                            />
                        </div>
                    </div>

                </div>
            </div>

            {/* Optional local fallback Coming Soon Modal */}
            {localComingSoonModal && (
                <div className="sw-crestest-modal-backdrop position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999 }}>
                    <div className="sw-crestest-modal-content bg-white p-4 rounded-4 shadow text-center position-relative mx-3" style={{ maxWidth: '400px', width: '100%' }}>
                        <h4 className="fw-bold mb-3" style={{ color: '#207AB4' }}>Coming Soon</h4>
                        <p className="text-secondary mb-4" style={{ fontSize: '14px' }}>
                            The Kirnavali Challenge is launching soon. Stay tuned for exciting updates!
                        </p>
                        <button
                            onClick={() => setLocalComingSoonModal(false)}
                            className="btn px-4 py-2 rounded-pill fw-bold text-white border-0"
                            style={{ backgroundColor: '#FBBB1B', fontSize: '14px' }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
}

export default SoftwareCrestest;

